<template>
  <div class="zheshang-screen-root">
    <iframe :src="iframeSrc" class="screen-iframe" frameborder="0" allowfullscreen></iframe>
  </div>
</template>

<script>
import { BaseApiUrl } from '../../api/base'
import { publicAssetUrl } from '@/utils/publicAssetUrl'

const queryKeys = [
  'schoolDepartmentId',
  'campusDepartmentId',
  'gradeDepartmentId',
  'classDepartmentId',
  'studentId',
  'semesterId',
  'periodType',
  'periodKey',
  'schoolName',
  'fitMode',
  'mock',
  'mockBizMode',
]

export default {
  name: 'ZheshangFiveEducationScreen',
  computed: {
    iframeSrc() {
      const source = new URLSearchParams(window.location.search)
      const params = new URLSearchParams({ apiBase: BaseApiUrl, _v: '20261014102' })
      const schoolDepartmentId = source.get('schoolDepartmentId')
        || source.get('departmentId')
        || (this.$store && this.$store.state && this.$store.state.activeSchoolId)
        || window.localStorage.getItem('activeSchoolId')
      if (schoolDepartmentId) params.set('schoolDepartmentId', String(schoolDepartmentId))
      const schoolName = source.get('schoolName')
        || (this.$store && this.$store.state && this.$store.state.activeSchoolName)
        || window.localStorage.getItem('activeSchoolName')
      if (schoolName) params.set('schoolName', String(schoolName))
      queryKeys.filter((key) => key !== 'schoolDepartmentId' && key !== 'schoolName').forEach((key) => {
        const value = source.get(key)
        if (value !== null && value !== '') params.set(key, value)
      })
      return `${publicAssetUrl('static/zheshang-big-screen/screen-shell.html')}?${params.toString()}`
    },
  },
  mounted() {
    window.addEventListener('message', this.handleIframeMessage)
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleIframeMessage)
  },
  methods: {
    /** 处理 iframe 发来的退出消息。创建于 2026-09-02 */
    handleIframeMessage(event) {
      if (event.data && event.data.type === 'ZHESHANG_SCREEN_BACK') {
        this.$router.go(-1)
      }
    },
  },
}
</script>

<style scoped>
.zheshang-screen-root {
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  overflow: hidden;
  background: #02071d;
}

.screen-iframe {
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
}
</style>




